import { IsNotEmpty, IsNumber, ValidateNested, IsArray, IsOptional, IsBoolean, Min } from "class-validator";
import { Transform, Type } from "class-transformer";
import { IBase, IDeliveryZone, IDeliveryZoneFees, ISchedule, PaymentType } from "../interfaces";

export class DeliveryZoneFeesDTO implements IDeliveryZoneFees {
    @IsNumber()
    @Type(() => Number)
    @Min(0)
    amount: number;

    @IsOptional()
    @IsNumber()
    @Type(() => Number)
    @Min(0)
    reducedAmount?: number;

    @IsOptional()
    @IsNumber()
    @Type(() => Number)
    @Min(0)
    reducedThreshold?: number;
}

export class DeliveryZoneDTO implements Omit<IDeliveryZone, keyof IBase> {
  @IsNotEmpty({ message: 'Le nom est requis' })
  name: string;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => DeliveryZoneFeesDTO)
  fees: DeliveryZoneFeesDTO;

  @IsNotEmpty({ message: 'La zone est requise' })
  location: {
    type: 'Polygon';
    coordinates: number[][][];
  };

  @IsOptional()
  @IsArray()
  paymentTypes: PaymentType[];

  @IsOptional()
  schedule: ISchedule;

  @IsOptional()
  @IsNumber()
  @Transform((params: { value: any } | null | undefined) => {
    const value = params?.value;
    if (value === '' || value === null || typeof value === 'undefined') {
      return undefined;
    }
    return Number(value);
  })
  extraDeliveryTime: number;

  @IsNumber()
  @Type(() => Number)
  minPrice: number;

  @IsBoolean()
  disabled: boolean;
}
